import React, { Component } from 'react';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom';
import logo from './images/logo-white.png';
import './App.css';
import Home from './components/Home';
import Skills from './components/Skills';
import Projects from './components/Projects';
import SingleProject from './components/SingleProject';


class App extends Component {
  
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Navbar className='square border border-0' collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
               
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav pullLeft>
                <NavItem className="nav-txt">
                <Link className="nb-logo" to="/"><img className="name-logo" src={logo} alt="logo"/></Link>
                </NavItem>
              </Nav>
              <Nav pullRight>
                <NavItem>
                <Link className="nb-links" to="/">Home</Link>
                </NavItem>
                <NavItem>
                <Link className="nb-links" to="/skills">Skills</Link>
                </NavItem>
                <NavItem>
                <Link className="nb-links" to="/projects">Projects</Link>
                </NavItem>
              </Nav>
          
             
            </Navbar.Collapse>
          </Navbar>

          <Switch>
            <Route exact={true} path="/" component={Home} />
            <Route path="/skills" component={Skills} />
            <Route path="/projects" component={Projects} />
            <Route exact={true} path="/project/:id"  component={props => <SingleProject {...props} />} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}


export default App;
